import React, { useMemo } from 'react';
import ImageZoom from 'react-medium-image-zoom';
import LinkCandidateProfile from '../../../../../../components/LinkCandidateProfile';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import LinkParser from '../../../../../../helpers/link-parser';
import StringHelpers from '../../../../../../helpers/string-helpers';
import FeedPostContentFirmLink from '../FeedPostContentFirmLink';

const TypeCandidateMood = props => {
  const {
    user,
    post: {
      CandidateID,
      FullName,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      currentSchoolName,
      NewsFeedDateAdd,
      Text,
      MoodFileUrl,
      MoodOriginalFileUrl,
      AdditionalParams,
      Date,
      ViewProfile,
      ViewAsRecruiter,
    },
  } = props;

  const text = Text ? StringHelpers.unescape(Text) : '';

  const postContent = useMemo(() => {
    if (MoodFileUrl) {
      return (
        <div className="feed-post-content__image-container">
          {Text && <p>{Text}</p>}
          <ImageZoom
            image={{
              src: MoodFileUrl,
            }}
            zoomImage={{
              src: MoodOriginalFileUrl,
              style: { backgroundColor: 'rgba(255,255,255, 0.2)' },
            }}
            shouldReplaceImage={false}
            defaultStyles={{
              overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
            }}
          />
        </div>
      );
    } else if (AdditionalParams && AdditionalParams.url) {
      const {
        url,
        title,
        titleEdited,
        content,
        contentEdited,
        images,
        currentImageIdx,
      } = AdditionalParams;

      const postTitle = StringHelpers.unescape(
        titleEdited.length > 0 ? titleEdited : title
      );
      const postText = StringHelpers.unescape(
        contentEdited.length > 0 ? contentEdited : content
      );
      const postLink = LinkParser.getFirmLinkOrigin(url);

      return (
        <>
          {text && <p>{text}</p>}
          <div style={{ marginTop: '10px' }}>
            <h4 className="feed-post-content__title">{postTitle}</h4>
            <div>
              <a
                className="feed-post-content__link"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {postLink}
              </a>{' '}
            </div>
          </div>
          <p>{postText}</p>
          {images && (
            <div className="feed-post-content__image-container">
              <img src={images[currentImageIdx]} alt="" />
            </div>
          )}
        </>
      );
    } else {
      return <p>{text}</p>;
    }
  }, [props.post]);

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <LinkCandidateProfile
          cls="feed-post-content__hero"
          clsSpan="feed-post-content__hero"
          styleSpan={{ marginRight: '0.5em' }}
          user={user}
          id={CandidateID}
          name={FullName}
          viewProfile={ViewProfile === 'Yes'}
          viewAsRecruiter={ViewAsRecruiter === 'Yes'}
        />
        <div className="feed-post-content__text">from</div>
        <FeedPostContentFirmLink
          isActive={FirmActive === 'Yes'}
          alias={FirmUrlAlias}
          firm={FirmName}
          school={currentSchoolName}
        />
      </div>
      <div className="feed-post-content__date">{date}</div>
      <div className="feed-post-content__content-middle">{postContent}</div>
    </div>
  );
};

export default TypeCandidateMood;
